import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconRedirectArrow: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconRedirectArrow"><Path d="M8 3C10.7614 3 13 5.23858 13 8V11H17.5859L15.293 8.70703L16.707 7.29297L21.4141 12L16.707 16.707L15.293 15.293L17.5859 13H13V21H11V13H8C5.23858 13 3 10.7614 3 8C3 5.23858 5.23858 3 8 3ZM8 5C6.34315 5 5 6.34315 5 8C5 9.65685 6.34315 11 8 11H11V8C11 6.34315 9.65685 5 8 5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconRedirectArrow;
